import type { Translations } from '../../types'

const menuMessages: Translations = {
  "menu.title": "Menu homepage",
  "menu.heading": "Gestione voci menu",
  "menu.description": "Gestisci il menu principale con ordine drag&drop e struttura a sottomenu.",
  "menu.badge": "Voce menu",
  "menu.empty": "Nessuna pagina ancora. Crea pagine nella sezione “Pagine” e collegale qui."
}

export default menuMessages
